import moment from 'moment'

export const DateUtils = {
  getMMYYYYFormat: (date: string): string => moment(date).format('MM/YYYY'),
  formatDate: (date: string, format: string = 'M/D/YYYY'): string => moment(date).format(format)
}